<div>

  <p-table class="config-history-table history-table" [value]="entries" [scrollable]="true" scrollHeight="calc(330px - 30px)"
    [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn>Device Name</th>
        <th pResizableColumn>Config Name</th>
        <th pResizableColumn>Timestamp</th>
        <th pResizableColumn style="max-width: 253px;">Config Value</th>
        <th pResizableColumn style="width: 8%;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.deviceName}}</div>
          </td>
        }
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.configName}}</div>
          </td>
        }
        <td pTooltip="{{formatDateHm(rowData.timestamp)}}">
          <div class="uv-table-value">{{formatDateHm(rowData.timestamp)}}</div>
        </td>
        <td pTooltip="{{rowData.configValue}}" style="max-width: 253px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          <div class="uv-table-value">{{rowData.configValue}}</div>
        </td>
        <td style="width: 8%;">
          <button type="button" pButton class="table-button" title="View this config"
          icon="fa fa-eye" (click)="viewConfig(rowData)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [(visible)]="displayViewConfigDialog" class="view-config-dialog" [resizable]="true"
    [modal]="true" [style]="{'max-width': '100%'}" appendTo="body">

    <p-header>
      <span>Config: {{configKey}}</span>
    </p-header>

    <pre>{{configText}}</pre>

    <p-footer>
      <button type="button" pButton icon="fa fa-file-o" iconPos="left" (click)="exportConfig()" label="Export"></button>
      <button type="button" pButton icon="fa fa-times" (click)="closeViewConfigDialog()" label="Close"></button>
    </p-footer>

  </p-dialog>



</div>
